(function ($) {

  let navigationHistory = [];

  let slideToRemoveAfterChange = null;

  const productList = [
    { nom: "POE 1", url: "https://bioligo-shop.myshopify.com/collections/preparations-oligoelements/products/poe-1-endoligo-algues" },
    { nom: "POE 2", url: "https://bioligo-shop.myshopify.com/collections/preparations-oligoelements/products/poe-2-digestoligo-radis-noir" },
    { nom: "POE 3", url: "https://bioligo-shop.myshopify.com/collections/preparations-oligoelements/products/poe-3-transitoligo-pruneau" },
    { nom: "POE 4", url: "https://bioligo-shop.myshopify.com/collections/preparations-oligoelements/products/poe-4-radicoligo-carotte" },
    { nom: "POE 5", url: "https://bioligo-shop.myshopify.com/collections/preparations-oligoelements/products/poe-5-oligaller-cassis" },
    { nom: "POE 6", url: "https://bioligo-shop.myshopify.com/collections/preparations-oligoelements/products/poe-6-feroligo-cresson" },
    { nom: "POE 7", url: "https://bioligo-shop.myshopify.com/collections/preparations-oligoelements/products/poe-7-trancoligo-fleur-doranger" },
    { nom: "POE 8", url: "https://bioligo-shop.myshopify.com/collections/preparations-oligoelements/products/poe-8-renoligo-genievre" },
    { nom: "POE 10", url: "https://bioligo-shop.myshopify.com/collections/preparations-oligoelements/products/poe-10-artriligo-reine-des-pres" },
    { nom: "POE 12", url: "https://bioligo-shop.myshopify.com/collections/preparations-oligoelements/products/poe-12-cardioligo-vigne-rouge" },
    { nom: "POE 13", url: "https://bioligo-shop.myshopify.com/collections/preparations-oligoelements/products/poe-13-artroligo-ortie" },
    { nom: "POE 14", url: "https://bioligo-shop.myshopify.com/collections/preparations-oligoelements/products/poe-14-immunoligo-sauge" },
    { nom: "POE 15", url: "https://bioligo-shop.myshopify.com/collections/preparations-oligoelements/products/poe-15-menoligo-yam" },
    { nom: "POE 16", url: "https://bioligo-shop.myshopify.com/collections/preparations-oligoelements/products/poe-16-drainoligo" },
    { nom: "POE 17", url: "https://bioligo-shop.myshopify.com/collections/preparations-oligoelements/products/poe-17-sportoligo-ginseng" },
    { nom: "POE 18", url: "https://bioligo-shop.myshopify.com/collections/preparations-oligoelements/products/poe-18-solution-precieuse" },
    { nom: "PROTAGEL", url: "https://bioligo-shop.myshopify.com/products/protagel-proteines-marines" }
  ];

  function goToPrevQuestion() {
    const currentSlideIndex = $('.formulaire__sante').slick('slickCurrentSlide');
    if (navigationHistory.length > 0) {
      slideToRemoveAfterChange = currentSlideIndex;
      navigationHistory.pop();
      $('.formulaire__sante').slick('slickPrev');
    } else {
      if (currentSlideIndex > 0) {
        slideToRemoveAfterChange = currentSlideIndex;
        $('.formulaire__sante').slick('slickPrev');
      }
    }
  }  

  function goToNextQuestion(nextStep) {
    const $currentSlide = $('.carousel__item.slick-current');
    const currentStepId = $currentSlide.data('question-id');
    if (currentStepId) {
      navigationHistory.push(currentStepId);
    }

    if (!nextStep) {
      $('.formulaire__sante').slick('slickNext');
      return;
    }

    const $existingSlide = $('.formulaire__sante').find(`.carousel__item[data-question-id="${nextStep}"], .carousel__item.${nextStep}`);

    if ($existingSlide.length > 0) {
      $('.formulaire__sante').slick('slickGoTo', $existingSlide.first().index());
      return;
    }

    // Sinon on clone la slide depuis la banque
    const $slideToAdd = $('#slides-bank').find(`.carousel__item.${nextStep}`).clone();

    if ($slideToAdd.length === 0) {
      console.warn(`Slide '${nextStep}' non trouvée dans la banque.`);
      return;
    }

    $('.formulaire__sante').slick('slickAdd', $slideToAdd);
    const newIndex = $('.formulaire__sante .carousel__item').length - 1;
    $('.formulaire__sante').slick('slickGoTo', newIndex);
  }

  function validateInput($slide) {
    const type = $slide.data('question-type');

    if (type === 'question_input_text' || type === 'question_input_date' || type === 'question_input_email') {
      const $input = $slide.find('input');
      const value = $input.val().trim();

      if (!value) {
        let message = "Merci de renseigner ce champ.";
        if (type === 'question_input_text') message = "Merci d'indiquer votre prénom.";
        if (type === 'question_input_date') message = "Merci d'indiquer votre date de naissance.";
        if (type === 'question_input_email') message = "Merci d'indiquer votre email.";
        alert(message);
        return false;
      }

      if (type === 'question_input_email') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          alert("Veuillez entrer une adresse email valide.");
          return false;
        }
      }
    }

    if (type === 'question_simple') {
      const $selected = $slide.find('.formulaire__answer.selected');
      if ($selected.length === 0) {
        alert("Merci de sélectionner une réponse.");
        return false;
      }

      const isAutreSelected = $selected.is('[data-specifique]');
      const $autreInputContainer = $slide.find('.other-input-container');

      if (isAutreSelected && $autreInputContainer.length) {
        const valeur = $autreInputContainer.find('input').val().trim();
        if (!valeur) {
          alert("Merci de préciser votre état.");
          return false;
        }
        $slide.attr('data-autre-valeur', valeur);
      }
    }

    return true;
  }
 

  $(document).ready(function () {
    $('.formulaire__sante').slick({
      accessibility: true,
      autoplay: false,
      arrows: false,
      dots: false,
      draggable: false,
      infinite: false,
      mobileFirst: true,
      swipe: false,
      touchMove: false,
      adaptiveHeight: true,
      touchThreshold: 5,
      initialSlide: 0,
    });

    let firstTransitionDone = false;
    $('.formulaire__sante').on('afterChange', function(event, slick, currentSlide) {
      if (slideToRemoveAfterChange !== null) {
        $('.formulaire__sante').slick('slickRemove', slideToRemoveAfterChange);
        slideToRemoveAfterChange = null;
      }

      const $currentSlide = $(slick.$slides[currentSlide]);

        if (currentSlide === 1 && !firstTransitionDone) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'start_diagnostic_ta'
            });
            firstTransitionDone = true;
        }

      if ($currentSlide.hasClass('end')) {
        const produits = calculerProduitsDepuisReponses();
        afficherProduitsRecommandes(produits);

          const email = $('input[name="email"]').val();
          console.log('submit_diagnostic_ta EVENT ' + email);
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
              event: 'submit_diagnostic_ta',
              user_data: {
                  email_address: email
              }
          });
      }
    });     

    $('.formulaire__sante').css('opacity', '1');

    $(document).on('click', '[data-action="slide-next"]', function (e) {
      const $btn = $(this);
      const $slide = $btn.closest('.carousel__item');

      if (!validateInput($slide)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      const questionType = $btn.data('question-type');
      if (questionType === 'question_simple') {
        const $selected = $slide.find('.formulaire__answer.selected');
        if ($selected.length === 0) {
          alert("Merci de sélectionner une réponse.");
          return false;
        }
      
        const customAnswers = $selected.filter('[data-custom-answer]');
        let nextStep = $selected.data('next-slide') || $selected.find('[data-next-slide]').data('next-slide');
        if (!nextStep) nextStep = $btn.data('next-slide');
      
        const isAutreSelected = $selected.is('[data-specifique]');
        const $autreInputContainer = $slide.find('.other-input-container');

        if (isAutreSelected && $autreInputContainer.length && $autreInputContainer.is(':hidden')) {
          $slide.find('.formulaire-question').hide();
          $autreInputContainer.show();
          return false;
        }

        if (customAnswers.length > 1) {
          goToNextQuestion(nextStep);
          return;
        }
      
        if ($selected.length === 1 && $selected.is('[data-custom-answer]')) {
          const message = customAnswers.data('custom-answer');
          const $messageBox = $slide.find('.formulaire-custom-answer-message');
      
          if ($messageBox.length) {
            $slide.find('.formulaire-question').hide();
            $messageBox.text(message).show();

            setTimeout(() => {
              goToNextQuestion(nextStep);
            }, 2000);
          } else {
            goToNextQuestion(nextStep);
          }
      
          return;
        }
        goToNextQuestion(nextStep);
      } else {
        goToNextQuestion($btn.data('next-slide'));
      }
    });

    $(document).on('click', '.other-input-container [data-action="slide-next"]', function () {
      const $btn = $(this);
      const $slide = $btn.closest('.carousel__item');
      const $input = $slide.find('.other-input-container input');
      const valeur = $input.val().trim();
    
      if (!valeur) {
        alert("Merci de préciser votre état.");
        return;
      }
    
      $slide.attr('data-autre-valeur', valeur);
    
      $slide.find('.other-input-container').hide();
      $slide.find('.formulaire-question').show();
      goToNextQuestion($btn.data('next-slide'));
    });    

    $(document).on('click', '[data-action="slide-prev"]', function () {
      goToPrevQuestion();
    });

    $(document).on('click', '.formulaire__answer', function () {
      const $clickedAnswer = $(this);
      const $answersList = $clickedAnswer.closest('.formulaire__answers_list');
      const isMultiple = $answersList.data('multiple-answers') === true || $answersList.data('multiple-answers') === 'true';
      const isAlone = $clickedAnswer.is('[data-alone]');
  
      if (!isMultiple) {
          $answersList.find('.formulaire__answer').removeClass('selected');
          $clickedAnswer.addClass('selected');
      } else {
          const $alreadySelectedAlone = $answersList.find('.formulaire__answer[data-alone].selected');
  
          if (isAlone) {
              $answersList.find('.formulaire__answer').removeClass('selected');
              $clickedAnswer.addClass('selected');
          } else {
              if ($alreadySelectedAlone.length > 0) {
                  $alreadySelectedAlone.removeClass('selected');
              }
              $clickedAnswer.toggleClass('selected');
          }
      }
  
      const $otherInputContainer = $answersList.closest('.formulaire-answers').find('.other-input-container');
      const isOtherSelected = $answersList.find('.formulaire__answer[data-specifique].selected').length > 0;
      $otherInputContainer.toggle(isOtherSelected);

      if (!isOtherSelected) {
        $otherInputContainer.find('input').val('');
      }
    });

    $(document).on('input', 'input[name="date_naissance"]', function () {
      let val = $(this).val().replace(/\D/g, '');

      if (val.length > 2 && val.length <= 4) {
          val = val.slice(0, 2) + '/' + val.slice(2);
      } else if (val.length > 4) {
          val = val.slice(0, 2) + '/' + val.slice(2, 4) + '/' + val.slice(4, 8);
      }

      $(this).val(val);
    });
    

    function calculerProduitsDepuisReponses() {
      const selectedProducts = [];
    
      $('.formulaire__sante .formulaire__answer.selected').each(function () {
        const data = $(this).data('product');
        if (!data) return;
    
        const entries = data.split('|');
        entries.forEach(entry => {
          const [nom, pointsStr] = entry.split(':');
          const points = parseInt(pointsStr, 10);
          if (!nom || isNaN(points)) return;
    
          const produitRef = productList.find(p => p.nom === nom);
          if (!produitRef) return;
    
          const existing = selectedProducts.find(p => p.nom === nom);
          if (existing) {
            existing.points += points;
          } else {
            selectedProducts.push({
              nom,
              points,
              url: produitRef.url
            });
          }
        });
      });
    
      return selectedProducts
        .filter(p => p.points > 0)
        .sort((a, b) => b.points - a.points)
        .slice(0, 2);
    }    
    
    function afficherProduitsRecommandes(produits) {
      console.log("Produits recommandés :", produits);

      const $endSlide = $('.carousel__item.end');
      const $texteElement = $endSlide.find('.formulaire-infos .h2');

      // Récupérer l'email et le prénom depuis les inputs
      const email = $('input[name="email"]').val();
      const prenom = $('input[name="prenom"]').val();

      if (produits.length === 2) {
        // const html = `Bonjour, ${prenom || 'cher utilisateur'} !<br><br>Les résultats de votre bilan de santé sont (cliquez sur les noms des produits pour les consulter) : le <a class="formulaire__sante--link" href="${produits[0].url}" target="_blank">${produits[0].nom}</a> et le <a class="formulaire__sante--link" href="${produits[1].url}" target="_blank">${produits[1].nom}</a> semblent être les produits adaptés pour soutenir vos métabolismes.`;
        const html = `Bonjour, ${prenom || 'cher utilisateur'} !<br><br>Nous vous remercions d'avoir pris le temps de remplir le bilan de santé.<br>Veuillez svp consulter votre boîte mail pour découvrir vos résultats.<br>L'équipe Bioligo`;
        $texteElement.html(html);

        envoyerEvenementKlaviyo(email, prenom, produits[0], produits[1]);

      } else {
        $texteElement.text("Nous n'avons pas pu déterminer deux produits adaptés à vos réponses.");
      }
    }

    function envoyerEvenementKlaviyo(email, prenom, produit, produit2) {
      const klaviyoPublicApiKey = 'Uu7pCy';

      const reponses = recupererQuestionsEtReponses();

      const payload = {
        token: klaviyoPublicApiKey,
        event: 'Bilan Santé Terminé',
        customer_properties: {
          $email: email,
          $first_name: prenom
        },
        properties: {
          $consent: ['email'],
          ProduitBilanSante: produit.nom,
          ProduitBilanSante2: produit2.nom,
          ...reponses
        }
      };

      const base64Payload = btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
      const img = new Image();
      img.src = `https://a.klaviyo.com/api/track?data=${base64Payload}`;

      console.log('Événement Klaviyo envoyé via pixel', img.src);

      mettreAJourProfilKlaviyo(email, prenom, produit, produit2, reponses);
    }

    function mettreAJourProfilKlaviyo(email, prenom, produit, produit2, reponses) {
      const klaviyoPublicApiKey = 'Uu7pCy';

      const payload = {
        token: klaviyoPublicApiKey,
        properties: {
          $email: email,
          $first_name: prenom,
          ProduitBilanSante: produit.nom,
          ProduitBilanSante2: produit2.nom,
          ...reponses
        }
      };

      const base64Payload = btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
      const img = new Image();
      img.src = `https://a.klaviyo.com/api/identify?data=${base64Payload}`;

      console.log('Profil Klaviyo mis à jour via pixel', img.src);
    }

    function recupererQuestionsEtReponses() {
      const reponses = {};

      $('.formulaire__sante .carousel__item').each(function () {
        const $slide = $(this);
        const questionTextRaw = $slide.find('.formulaire-question .question h2').text().trim();

        if (!questionTextRaw) return;

        const questionKey = "Bilan_Sante_" + supprimerAccents(questionTextRaw)
          .replace(/-/g, '_')
          .replace(/\s+/g, ' ')
          .replace(/[?]/g, '')
          .replace(/[^a-zA-Z0-9 ]/g, '')
          .trim()
          .replace(/\s/g, '_');

        const type = $slide.data('question-type');
        let reponsesQuestion = [];

        if (type === 'question_input_text' || type === 'question_input_date') {
          const valeur = $slide.find('input').val();
          if (valeur) {
            reponsesQuestion.push(valeur.trim());
          }
        } else if (type === 'question_simple') {
          const $selected = $slide.find('.formulaire__answer.selected');
          if ($selected.length === 0) return;


          reponsesQuestion = $selected.map(function () {
            if ($(this).is('[data-specifique]')) {
              return $(this).text().trim() + ' - ' + ($slide.attr('data-autre-valeur') || '');
            }
            return $(this).text().trim();
          }).get();
        }

        if (reponsesQuestion.length > 0) {
          reponses[questionKey] = (reponsesQuestion.length === 1) ? reponsesQuestion[0] : reponsesQuestion;
        }
      });
      return reponses;
    }

    function supprimerAccents(texte) {
      return texte.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

  });
})(jQuery);